import React, { useEffect, useState } from 'react';
import Head from '../../layout/head/Head';
import Content from '../../layout/content/Content';
import { Block, BlockBetween, BlockHead, BlockHeadContent, Icon } from '../../components/Component';
import AfrocentecLogo from "../../images/afrocentec_logo.png";
import Katundu360Logo from "../../images/logo.png";
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { no_tenant_actions_helper } from '../../actions/actions_helper';
import * as app_consts from "../../utils/app_consts";
import { fail_main_system_loader, loading_main_system_loader, reset_main_system_loader, success_main_system_loader } from '../../reducers/system_loaders/main_system_loader_Slice';
import { MAIN_SYSTEM_LOADER_ERROR_MSG, MAIN_SYSTEM_LOADER_SUCCESS_MSG } from '../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { fetchImageAsBase64, messageToast } from '../../utils/Utils';

const MainSystemLoader = () => {

  const { tenant_url_prefix } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [tenant_data, setTenantData] = useState([]);

  // Search for Tenant From API
  useEffect(() => {
    // Dispatch
    dispatch(no_tenant_actions_helper(loading_main_system_loader, success_main_system_loader, fail_main_system_loader, MAIN_SYSTEM_LOADER_ERROR_MSG, MAIN_SYSTEM_LOADER_SUCCESS_MSG, app_consts.GET, `/${tenant_url_prefix}`));
  }, []);


  // Listen
  const main_system_loader_listener = useSelector((state) => state.main_system_loader.main_system_loader);

  useEffect(() => {
    if (main_system_loader_listener.status !== app_consts.IDLE)
    {
      if (main_system_loader_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoading(false);
        if (main_system_loader_listener.status === app_consts.FAIL)
        {
          setError(main_system_loader_listener.message, app_consts.FAIL);
          messageToast(main_system_loader_listener.message, app_consts.FAIL);
        } else if (main_system_loader_listener.status === app_consts.SUCCESS)
        {
          setTenantData(main_system_loader_listener.data);

        }
        dispatch(reset_main_system_loader());
      }
    }
  }, [main_system_loader_listener]);

  useEffect(() => {
    if (tenant_data?.tenant && localStorage.getItem("dashboard_tenant"))
    {
      update_tenant_to_base_64();
    }
  }, [tenant_data]);

  const update_tenant_to_base_64 = async () => {
    const updated_tenant = { ...tenant_data?.tenant, ["tenant_logo"]: await fetchImageAsBase64(tenant_data?.tenant?.tenant_logo) };

    // Update Localstroage
    localStorage.setItem('dashboard_tenant', JSON.stringify(updated_tenant));

    setTimeout(() => {
      // Your code to run after 1500 milliseconds (Because of Localstorage Setup)
      window.location.assign(`/${tenant_url_prefix}/auth`);
    }, 2000);
  };


  return (
    <>
      <Head title="Setting Up Environment" />
      <Content page="component" >
        <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
          <Block size="lg">
            <BlockBetween className="center">
              <BlockHead>
                <BlockHeadContent>
                  {
                    loading ?
                      <>
                        <div className="brand-logo text-center" style={{ marginBottom: 12 }}>
                          <img className="logo-custom-img-main_app_loading w-70" src={Katundu360Logo} alt="logo-dark" />
                        </div>
                        <div className="text-soft fw-bold mt-6" style={{ fontSize: 24 }}>Setting up Environment ...</div>
                        <div className="nk-loader"></div>
                      </>
                      :
                      <>
                        {
                          error && error.length > 0 ?
                            <>
                              <div className="brand-logo text-center" style={{ marginBottom: 12 }}>
                                <img className="logo-custom-img-main_app_loading w-70" src={Katundu360Logo} alt="logo-dark" />
                              </div>
                              <hr />
                              <div>
                                <Icon name="alert-circle" className="text-danger" style={{ fontSize: 28 }} /> <div className="text-soft fw-bold mt-6" style={{ fontSize: 24 }} >{error}</div>{" "}
                              </div>
                            </>
                            :
                            <>
                              <div className="brand-logo text-center" style={{ marginBottom: 12 }}>
                                <img className="logo-custom-img-main_app_loading w-70" src={Katundu360Logo} alt="logo-dark" />
                              </div>
                              <div className="text-soft fw-bold mt-6" style={{ fontSize: 24 }}>Redirecting ...</div>
                            </>
                        }
                      </>
                  }
                </BlockHeadContent>
              </BlockHead>
            </BlockBetween>
          </Block>
        </div>
      </Content>
    </>
  );
};

export default MainSystemLoader;